module.exports = __webpack_public_path__ + "img/hy-logo4.59763459.png";